<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useAutoDelivery } from '@/stores/autoDelivery';

const { autoDeliveryChannel } = storeToRefs(useAutoDelivery());
</script>

<template>
  <div class="flex flex-col-reverse md:mt-12 lg:flex-row lg:h-96">
    <div class="flex-col py-8 px-9 md:max-w-3xl md:px-12 bg-nuts-orange-50">
      <div
        class="flex flex-col items-center justify-center lg:flex-col lg:items-start lg:justify-start md:flex-row"
      >
        <h4 class="mb-2 text-xl font-bold md:mb-0 lg:text-2xl font-sofia-pro md:pr-2">Shop with</h4>
        <img
          class="h-8 md:h-6 lg:h-10"
          src="@/assets/auto-delivery/logo.svg"
          alt="Auto Delivery Logo"
        />
      </div>
      <ul class="pt-4">
        <li class="flex flex-row items-center justify-start mb-3 lg:mb-6">
          <img class="pr-8" src="@/assets/auto-delivery/subscribe.svg" alt="Subscribe icon" />
          <p class="m-0 text-sm font-proxima-nova">
            Sign Up &amp; Save: <strong>Get {{ autoDeliveryChannel.discount }}% off</strong>
            on your first and all future orders.
          </p>
        </li>
        <li class="flex flex-row items-center justify-start mb-3 lg:mb-6">
          <img class="pr-8" src="@/assets/auto-delivery/cart.svg" alt="Cart icon" />
          <p class="m-0 text-sm font-proxima-nova">
            Easy Ordering: Choose the quantity and frequency that work
            <strong>best for you.</strong> We'll send you a reminder email before each delivery.
          </p>
        </li>
        <li class="flex flex-row items-center justify-start">
          <img class="pr-8" src="@/assets/auto-delivery/truck.svg" alt="Truck icon" />
          <p class="m-0 text-sm font-proxima-nova">
            Flexible Scheduling: <strong>No fixed plans</strong> – skip, postpone and cancel at any
            time, free of charge.
          </p>
        </li>
      </ul>
    </div>
    <!-- Desktop  -->
    <img
      class="hidden object-cover h-60 lg:object-right lg:object-cover lg:h-full lg:w-7/12 md:object-contain md:w-full lg:visible lg:block"
      src="@/assets/auto-delivery/full-bleed-homepage-banner.jpg"
      alt="Auto Delivery Hero Banner"
    />
    <!-- Mobile / Tablets -->
    <img
      class="block object-cover h-60 lg:h-full lg:w-7/12 md:w-full lg:hidden"
      src="@/assets/auto-delivery/auto-delivery-mobile-banner.jpg"
      alt="Auto Delivery Hero Banner"
    />
  </div>
</template>
